import { render, staticRenderFns } from "./addTapPop.vue?vue&type=template&id=04196125"
import script from "./addTapPop.vue?vue&type=script&lang=js"
export * from "./addTapPop.vue?vue&type=script&lang=js"
import style0 from "./addTapPop.vue?vue&type=style&index=0&id=04196125&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports